import { useCallback, useEffect, useState, useSyncExternalStore } from 'react';
import type { Helix2000Character } from '../../shared/CharacterTypes';
import {
  MultiplayerDiagnosticsState,
  getMultiplayerDiagnosticsRuntime,
} from './multiplayerDiagnostics';

export function useMultiplayerDiagnostics(): MultiplayerDiagnosticsState {
  const runtime = getMultiplayerDiagnosticsRuntime();
  const [state, setState] = useState<MultiplayerDiagnosticsState>(() => runtime.getState());

  useEffect(() => {
    return runtime.subscribe(setState);
  }, [runtime]);

  return state;
}

/**
 * Only the remote-player roster. The runtime samples every 250 ms and hands
 * out a new state object each time, so a component that needs just the
 * roster must not take the whole state: `Game` did, and re-rendered (with the
 * HUD and every hotbar slot under it) 4 times a second on every map (B7, lane
 * AB 2026-10-08). The roster Map keeps its identity until a player joins,
 * leaves or is replaced (K15), so this re-renders only then.
 */
export function useMultiplayerOtherPlayers(): Map<string, Helix2000Character> {
  const runtime = getMultiplayerDiagnosticsRuntime();
  const subscribe = useCallback((onChange: () => void) => runtime.subscribe(() => onChange()), [runtime]);
  const read = useCallback(() => runtime.getState().otherPlayers, [runtime]);
  return useSyncExternalStore(subscribe, read, read);
}
